<template>
    <v-text-field
        v-model="search"
        :label="$t('address.searchAddress')"
        append-icon="mdi-magnify"
        :loading="loading"
        clearable
        rounded
        solo
        @click:append="getLocationSearched"
        @click:clear="searchCleared"
    ></v-text-field>
</template>

<script>
import axios from 'axios';
import { GeoCodeApiKey, GeoCodeBaseUrl } from "@/constants";
import L from "leaflet";

export default {
    name: "BuscaEndereco",
    data: () => ({
        search: null,
        loading: false,
        location: {
            lat: null,
            lng: null,
            marker: null,
            address: null,
        }
    }),
    methods: {
        getLocationSearched() {
            if (this.search != null && String(this.search).trim().length > 0) {
                this.loading = true;
                const url = GeoCodeBaseUrl + 
                    encodeURIComponent(this.search) +
                    "&limit=1&types=address" +
                    "&access_token=" + GeoCodeApiKey;
                axios
                .get(url)
                .then((response) => {
                    if (response.data.features.length === 0) {
                        alert(this.$t('routeNotFound.title'));
                        this.$emit('search', null);
                    } else {
                        this.location.lat = response.data.features[0].properties.coordinates.latitude;
                        this.location.lng = response.data.features[0].properties.coordinates.longitude;
                        
                        let endereco = document.createElement('pre');
                        endereco.innerHTML = this.search;
                        this.location.marker = L
                            .marker([this.location.lat, this.location.lng])
                            .bindPopup(endereco, { autoClose: false, closeOnClick: false, closeButton: false, maxWidth: 'fit-content', maxHeight: 20})
                            .on('click', (e) => {
                                window.open(`https://www.google.com/maps/@${e.latlng.lat},${e.latlng.lng},18z`, '_blank').focus();
                            });
                        this.location.address = endereco;
                        this.$emit('search', this.location);
                    }
                    this.loading = false;
                })
                .catch((e) => {
                    this.loading = false;
                    console.log(this.$t('system.messages.errorAxios'));
                    console.log(e.message);
                });
            }
        },
        searchCleared() {
            this.$emit('clear');
        }
    }
}
</script>

<style>
    
</style>